<h3 class="report-count">{{ reportsTable.data.length || "0"}} Reports</h3>
<table mat-table [dataSource]="reportsTable" class="report-table">
  <ng-container matColumnDef="filler">
    <th mat-header-cell *matHeaderCellDef class="filler-column" style="width: 48px;"></th>
    <td mat-cell *matCellDef="let report" class="filler-column"></td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Report Name</th>
    <td mat-cell *matCellDef="let report">
      <a [routerLink]="'/report-overview'" [queryParams]="{report_id: report.report_id}">
        {{fire?.baer_name}} ({{report.report_num ?? "--"}})
      </a>
    </td>
  </ng-container>
  <ng-container matColumnDef="reportId">
    <th mat-header-cell *matHeaderCellDef>Report ID</th>
    <td mat-cell *matCellDef="let report" class="prewrap">{{report.report_id || "--"}}</td>
  </ng-container>
  <ng-container matColumnDef="action_type">
    <th mat-header-cell *matHeaderCellDef>Action Type</th>
    <td mat-cell *matCellDef="let report" class="prewrap">{{report.report_num == 0 ? "Pre-assessment" : report.report_num == 1 ? "Initial" : "Interim"}}</td>
  </ng-container>
  <ng-container matColumnDef="report_type">
    <th mat-header-cell *matHeaderCellDef>Report Type</th>
    <td mat-cell *matCellDef="let report" class="prewrap">{{report.report_type || "--"}}</td>
  </ng-container>
  <ng-container matColumnDef="funding_requested">
    <th mat-header-cell *matHeaderCellDef>Funding Requested</th>
    <td mat-cell *matCellDef="let report" class="prewrap">{{ report.funding_requested? (report.funding_requested | currency) : "--"}}</td>
  </ng-container>
  <ng-container matColumnDef="authorized_funding">
    <th mat-header-cell *matHeaderCellDef>Authorized Funding</th>
    <td mat-cell *matCellDef="let report" class="prewrap">{{ report.authorized_funding? (report.authorized_funding | currency) : "--"}}</td>
  </ng-container>
  <ng-container matColumnDef="sumbission_date">
    <th mat-header-cell *matHeaderCellDef>Submission Date</th>
    <td mat-cell *matCellDef="let report" class="prewrap">{{(report.submission_date | date:"MM/dd/yyyy") || "--"}}
    </td>
  </ng-container>
  <ng-container matColumnDef="reportStatus">
    <th mat-header-cell *matHeaderCellDef>Report Status</th>
    <td mat-cell *matCellDef="let report">
      @if (report.report_status_id != null) {
        <mat-chip [ngClass]="'chip-r-'+report.report_status_id">
          {{report.report_status_id | reportStatusBadge}}
        </mat-chip>
      }
      @if (report.report_status_id == null) {
        <span>--</span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="authorization_status">
    <th mat-header-cell *matHeaderCellDef>Authorization Status</th>

    <td mat-cell *matCellDef="let report" class="prewrap">
      @if (report.authorization_status_id != null) {
        <mat-chip
          [ngClass]="'chip-a-'+report?.authorization_status_id">
          {{report.authorization_status_id | authorizationStatusBadge}}
        </mat-chip>
      }
      @if (report.authorization_status_id == null) {
        <span>--</span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="comments">
    <td class="empty-header" mat-header-cell *matHeaderCellDef></td>
    <td mat-cell *matCellDef="let report" class="prewrap">
      <div class="icon-message">
        @if(report.comments_unresolved) {
          <fa-icon [icon]="faMessage" class="chat-count-red" aria-label="chat"></fa-icon><span class="button-text chat-text-red"
          matTooltip='The report has comments that need to be revised and completed before submission.'
          matTooltipClass="tooltipClass">{{report.comments?.length ??
        0}}</span>
      } @else {
        <fa-icon [icon]="faMessage" class="chat-count" aria-label="chat"></fa-icon><span class="button-text chat-text"
        matTooltip='There are no open comments on the report.'
      matTooltipClass="tooltipClass">{{report.comments?.length ?? 0}}</span>
    }
  </div>
</td>
</ng-container>
<ng-container matColumnDef="action">
  <th mat-header-cell *matHeaderCellDef style="width: 270px;">
    <div class="info-containment-div">Actions</div>
  </th>
  <td mat-cell *matCellDef="let report" style="width: 270px;">
    <div class="action-div">
      @if (report.actions[0] == 'edit') {
        <button class="first-action"
          [routerLink]="'/2500-8-report'" [queryParams]="{report_id: report.report_id}">
          <fa-icon class="fa-sm" [icon]="faEdit"></fa-icon>Edit Report</button>
        }

        @if (report.actions[0] == 'view') {
          <button class="first-action"
            [routerLink]="'/report-overview'" [queryParams]="{report_id: report.report_id}"><fa-icon
          class="fa-sm" [icon]="faFileLines"></fa-icon>View Report</button>
        }

        <button class="menu-btn" [matMenuTriggerFor]="menu" aria-label="Individual assessment action list"
          #t="matMenuTrigger" (click)="stopPropagation($event)" class="{{t.menuOpen ? 'menuOpen' : ''}}">
          @if (t.menuOpen) {
            <mat-icon>keyboard_arrow_up</mat-icon>
          } @else {
            <mat-icon>keyboard_arrow_down</mat-icon>
          }
        </button>
        <mat-menu #menu="matMenu" class="action-menu" yPosition="below">
          @for (action of report.actions; track action) {
            @if (action != report.actions[0]) {
              @if (action == 'view') {
                <button mat-menu-item [routerLink]="'/report-overview'"
                  [queryParams]="{report_id: report.report_id}">
                  <div><fa-icon class="fa-sm" [icon]="faFileLines"></fa-icon></div>
                  <span>View Report</span>
                </button>
              }
              @if (action == 'download' && report.page_1_status_id == 2 && report.page_2_status_id == 2 && report.page_3_status_id == 2) {
                <button mat-menu-item  (click)="download(report.report_id)">
                  <fa-icon class="fa-sm" [icon]="faFileArrowDown"></fa-icon>
                  <span>Export PDF</span>
                </button>
              }
              @if (action === 'delete') {
                <button mat-menu-item
                  (click)="onDelete(report); $event.stopPropagation();" class="delete-button"
                  >
                  <fa-icon class="fa-sm" style="color: #D60036 !important;vertical-align: -2px;margin-right: 13px;"
                  [icon]="faTrash"></fa-icon>
                  <span>Delete Report</span>
                </button>
              }
              @if (action === 'revert') {
                <button mat-menu-item
                  (click)="sendBack(report); $event.stopPropagation();" class="revert-button"
                  >
                  <fa-icon class="fa-sm" style="color: #D60036 !important;vertical-align: -2px;margin-right: 13px;"
                  [icon]="faArrowRotateLeft"></fa-icon>
                  <span>Send Back</span>
                </button>
              }
            }
          }

        </mat-menu>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  <!-- Row shown when there is no matching data. -->
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="11">
      <div class="no-data">
        <div class="no-data-icon">
          <img class="no-data-icon3" src="assets/img/empty-state-page.svg" alt="No Reports">
        </div>
        <div class="no-data-title">No Reports Have Been Created</div>
      </div>
    </td>
  </tr>
</table>
